import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ChatContainer from './ChatContainer';
import ChatContainerXA3 from './ChatContainerXA3';
import RedirectChatCointainer from './RedirectChatCointainer';

/* eslint import/namespace: "off", import/default: "off", import/no-named-as-default: "off",
  import/no-named-as-default-member: "off", react/jsx-no-bind: "off"*/

export default class SdkContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            xaThree: true
        };
    }

    componentDidMount() {
        let params = new URLSearchParams(window.location.search);
        let xaThreeParam = params.get('XA3');

        if (xaThreeParam === 'active') {
            this.setState({ xaThree: true });
        }

        document.dispatchEvent(
            new CustomEvent('c-tracking-log-page', {
                bubbles: true,
                detail: {
                    screenName: 'chat landing page',
                },
            })
        );
    }

    render() {
        return (
            <Switch>
                <Route
                    path="/chat/"
                    exact
                    component={
                        this.state.xaThree ? ChatContainerXA3 : ChatContainer
                    }
                />
                <Route
                    path="/chat/redirectchat/"
                    exact
                    component={RedirectChatCointainer}
                />
                <Route exact path="/">
                    <Redirect to="/chat/" />
                </Route>
            </Switch>
        );
    }
}
